import { ExternalDocSearchInfo, ExternalDocPatientInfo, ExternalDocument } from '../../models/estensa-models.model';

export interface ExternalDocsState {
    info: ExternalDocSearchInfo;
    patientInfo: ExternalDocPatientInfo;
    examinationsInfo: string[],
    selectedDoc?: ExternalDocument
}


export const externalDocsInitialState: ExternalDocsState = {
    info: null,
    patientInfo: null,
    examinationsInfo: null,
    selectedDoc: null
};
